import React from 'react';
import Dropdown from './Dropdown';
import { Link } from 'react-router-dom';



class NavbarElement extends React.Component {

  render() {
    let token = this.props.token;
    let dataValue = this.props.dataValue;
    let dropdown = this.props.dropdown;
    let navbarElementOver = this.props.navbarElementOver;
    return (
      dropdown ?
        <li
          className='navbar-right-element' 
          data-value={dataValue}
          onMouseEnter={this.props.dropdownOnHandle}
          onMouseLeave={this.props.dropdownOffHandle}
        >
          <div className='navbar-title'>
            <div className='navbar-right-link'>
              {this.props.title}
            </div>
          </div>
          {
            navbarElementOver === dataValue ?
              <div className='dropdown-container'>
                <Dropdown
                  type={this.props.dropdownType}
                  activeTitle={this.props.dropdownActiveTitle}
                  options={this.props.dropdownOptions}
                  languageHandle={this.props.languageHandle}
                  dropdownOffHandle={this.props.dropdownOffHandle}
                  navbarElementClicked={this.props.navbarElementClicked}
                />
              </div>
              : ''
          }
        </li>
        :
        <li
          id={this.props.id}
          className='navbar-right-element-start'
          data-value={dataValue}
          onClick={this.props.navbarAnimationHandle}
        >
          <div className='navbar-title'>
            {
              dataValue === 'home' ?
                this.props.navbarType === 'unauthenticated' ?
                  <a className='navbar-right-link' href={this.props.href}>
                    {this.props.title}
                  </a>
                  : this.props.navbarType === 'authenticated' ?
                    <a className='navbar-right-link' href={this.props.href}>
                      {this.props.title}
                    </a>
                    :
                    token ?
                      <Link to='/authenticated'>
                        <div className='navbar-right-link'>
                          {this.props.title}
                        </div>
                      </Link>
                      :
                      <Link to='/'> 
                        <div className='navbar-right-link'>
                          {this.props.title}
                        </div>
                      </Link>
                :
                <a className='navbar-right-link' href={this.props.href}>
                  {this.props.title}
                </a>
            }
          </div>
        </li>
    )
  }
}

export default NavbarElement;